import PropTypes from "prop-types";
import muiTheme from "./muiTheme";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { useMemo } from "react";
import useLocale from "providers/LocaleProvider/useLocale";
import ThemeHelpers from "helpers/ThemeHelpers";

function MuiThemeProvider(props) {
  const { locale } = useLocale();

  /**
   * Create a new theme with the selected locale
   * To learn more about MUI locales, check the documentation
   * @see https://mui.com/material-ui/guides/localization
   */
  const themeWithLocale = useMemo(
    () => createTheme(muiTheme, ThemeHelpers.muiLocaleThemeConstructor(locale)),
    [locale]
  );
  return <ThemeProvider theme={themeWithLocale}>{props.children}</ThemeProvider>;
}

MuiThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MuiThemeProvider;
